import _ from 'lodash';

export interface ApproverArgs {
  approve_stage?: number;
  name?: string;
  birthday?: string;
  [key: string]: unknown;
}

/**
 * approve_stage値を安全に比較する関数
 */
export function compareApproveStage(a: number | undefined, b: number | undefined): number {
  if (a === undefined || b === undefined) {
    return -1;
  }

  const aValue = a === null ? 0 : a;
  const bValue = b === null ? 0 : b;

  return aValue - bValue;
}

class Approver {
  approve_stage?: number;

  name?: string;

  birthday: string;

  constructor(args: ApproverArgs = {}) {
    const safeArgs = args || {};
    _.assign(this, safeArgs);
    this.birthday = safeArgs.birthday || '';
  }
}

export default Approver;
